export { default } from './PoliticsAndTerms';
